export default __webpack_public_path__ + "static/media/Yellow0004.28d51b1c.png";